import {
  Button,
  Drawer,
  Form,
  Space,
  DatePicker,
  Select,
  TimePicker,
  InputNumber,
  Input,
} from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import moment from "moment";

const CreateOvertime = ({
  open,
  close,
  employeeInfo,
  rerun,
  date_from,
  date_to,
  perMinute,
  perHour,
}) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const { userData } = useContext(UserInfo);
  // const [selectedDate, setSelectedDate] = useState(null);
  const [timeIn, setTimeIn] = useState(null);
  const [timeOut, setTimeOut] = useState(null);

  // console.log("perMinute: ", perMinute);
  // console.log("perHour: ", perHour);

  const handleCreateOvertime = (values) => {
    const formdata = new FormData();
    formdata.append("merchant_id", userData.data.id);
    formdata.append(
      "user_id",
      employeeInfo.ready && employeeInfo.data[0].user_id
    );
    formdata.append("date_from", date_from);
    formdata.append("date_to", date_to);
    formdata.append("ot_time_in", timeIn !== null ? timeIn : null);
    formdata.append("ot_time_out", timeOut !== null ? timeOut : null);
    formdata.append("ot_minutes", getMinutesDifference(timeIn, timeOut));
    formdata.append("ot_per_hour", perHour);
    formdata.append("ot_per_minute", perMinute);

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    // setLoading(true);
    axios
      .post("user/merchant/create/employee-overtime", formdata)
      .then((response) => {
        const data = response.data;
        if (data.message === "success") {
          rerunNotif("success", "Created overtime successfully.");
          setTimeout(() => {
            rerun();
            close();
            setLoadings(false);
            // setLoading(false);
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  function getMinutesDifference(timeFrom, timeTo) {
    const fromTime = moment(timeFrom, "HH:mm:ss");
    let toTime = moment(timeTo, "HH:mm:ss");
    if (toTime.isBefore(fromTime)) {
      toTime.add(1, "day");
    }
    const differenceInMinutes = toTime.diff(fromTime, "minutes");
    return differenceInMinutes;
  }

  return (
    <Drawer
      title="Create Overtime"
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      <Form
        layout="vertical"
        name="add-employee-overtime"
        onFinish={handleCreateOvertime}
        autoComplete="off"
      >
        <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
          <Form.Item
            name="ot_date"
            label="Date"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <DatePicker
              format={"MM/DD/YYYY"}
              size="large"
              style={{ width: "100%" }}
              // onChange={(e) =>
              //   setSelectedDate(moment(new Date(e)).format("YYYY-MM-DD"))
              // }
            />
          </Form.Item>

          <Form.Item
            name="time_in"
            label="Time in"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <TimePicker
              format={"HH:mm"}
              onChange={(value, dateString) => {
                if (dateString !== "") {
                  var date = `2023-11-23 ${dateString}:00`;
                  var finalDate = moment(`${date.replace(" ", "T")}.000000Z`)
                    .utc()
                    .format("HH:mm:ss");
                  setTimeIn(finalDate);
                } else {
                  setTimeIn(null);
                }
              }}
              size="large"
              required
              style={{ width: "100%" }}
            />
          </Form.Item>

          <Form.Item
            name="time_out"
            label="Time out"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <TimePicker
              format={"HH:mm"}
              onChange={(value, dateString) => {
                if (dateString !== "") {
                  var date = `2023-11-23 ${dateString}:00`;
                  var finalDate = moment(`${date.replace(" ", "T")}.000000Z`)
                    .utc()
                    .format("HH:mm:ss");
                  setTimeOut(finalDate);
                } else {
                  setTimeOut(null);
                }
              }}
              size="large"
              required
              style={{ width: "100%" }}
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            loading={loadings}
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            {loadings ? "Loading" : "Create"}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
};

export default CreateOvertime;
